"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReferenceElementWidth = useReferenceElementWidth;
var React = _interopRequireWildcard(require("react"));
var _size = require("../../styles/variables/_size");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MIN_FLUID_WIDTH = 160;
function useReferenceElementWidth(ref) {
  let minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MIN_FLUID_WIDTH;
  const [width, setWidth] = React.useState(_size.sizeFluid);
  const refWidth = ref?.offsetWidth;
  React.useLayoutEffect(() => {
    if (refWidth) {
      setWidth(Math.max(refWidth, minWidth) + 'px');
    }
  }, [refWidth, minWidth]);
  return width;
}